module.exports = __webpack_public_path__ + "img/Groupe 515.34952f6d.svg";